export default __webpack_public_path__ + "static/media/SEC1560.34I-39024_-22887_0.33b363ab.jpg";